import { SelectOption } from '../Common/Forms/SelectSearch';
import { UserRoleDto } from '../Requests/useGetUsers';

export const UserRoleNames = {
  administrator: 'Administrator',
  standard: 'Standard User',
};

export const toRoleSelectOptions = (roles: UserRoleDto[]): SelectOption[] =>
  roles.map(r => ({ value: r.id, name: r.name }));
